import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { SectionHeader } from '../components/SectionHeader';
import { ValuesSection } from '../components/ValuesSection';
import { CoachCard, Coach } from '../components/CoachCard';
import { CoachModal } from '../components/CoachModal';
export function AboutPage() {
  const [selectedCoach, setSelectedCoach] = useState<Coach | null>(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const coaches: Coach[] = [{
    id: '1',
    name: 'Donna Kellogg',
    role: 'Lead Coach',
    credentials: 'BSc (Hons) MBE OLY',
    image: 'https://cdn.magicpatterns.com/uploads/4ASxFGF7ivucC7XtmD1BzK/donna_pic_cropped-768x767.webp',
    bio: 'Triple Olympian who represented Team GB at the 2000, 2004 and 2008 Olympic Games. Multiple world, Commonwealth and European championship medallist.',
    fullBio: "Donna is a fantastic sporting role model for all our Bright Star Sports children. She is a triple Olympian having represented Team GB at the 2000, 2004 and 2008 Olympic Games and is a multiple world, Commonwealth and European championship medallist. Donna has loved her life in sport and hopes to inspire more young children to have fun, build their confidence and value the friendships they make whilst participating in sport and physical activity.\n\nShe has coached all ages and abilities over the years having been involved with school programmes, holiday camps and coaching workshops. Donna's two young daughters enjoy trying out the latest content in our Bright Star Sports sessions and give Mum plenty of feedback.",
    achievements: ['Triple Olympian (2000, 2004, 2008)', 'Multiple World Championship Medallist', 'Commonwealth Championship Medallist', 'European Championship Medallist', 'Awarded MBE'],
    philosophy: 'I hope to inspire more young children to have fun, build their confidence and value the friendships they make whilst participating in sport and physical activity.'
  }, {
    id: '2',
    name: 'Natalie Barton',
    role: 'Lead Coach',
    credentials: 'BSc (Hons) OLY',
    image: 'https://cdn.magicpatterns.com/uploads/ocRMerKbd1woFGMKYSm6JS/natalie_pic_cropped-768x767.webp',
    bio: "Multi-talented sportswoman who represented Team GB at the 2004 Olympic Games. Former international badminton player with a career-high ranking inside the world's top 5.",
    fullBio: "Natalie is a multi-talented sportswoman having competed in many sports to a high level and represented Team GB at the 2004 Olympic Games. She is a former international badminton player with a career-high ranking inside the world's top 5 and still enjoys competing for Hertfordshire in the Inter Counties Premiership.\n\nNatalie is a highly accomplished PE teacher, delivering a full curriculum of sports to children aged 3 to 18. She ensures all Bright Star Sports workshops and classes create a supportive and fun environment where children can come and explore new sports, learn new skills and be inspired and encouraged to achieve their goals.",
    achievements: ['Olympic Games Representative (2004)', 'World Top 5 Ranking', 'Inter Counties Premiership Competitor', 'Accomplished PE Teacher'],
    philosophy: 'Creating a supportive and fun environment where children can explore new sports, learn new skills and be inspired and encouraged to achieve their goals.'
  }, {
    id: '3',
    name: 'Sarah Chapman',
    role: 'Lead Coach',
    credentials: 'MSc BSc (Hons) OLY',
    image: 'https://cdn.magicpatterns.com/uploads/pQyrJ9Go8cTY1DPUpopDaC/sarah_chapman_cropped-768x767.webp',
    bio: 'Team GB Olympic star who competed at the Sydney 2000 Olympic Games. European championship medallist with a career-high ranking inside the world top 10.',
    fullBio: 'Sarah is another of our Team GB Olympic stars and competed at the Sydney 2000 Olympic Games. She is a European championship medallist, won multiple international badminton tournaments and achieved a career-high ranking inside the world top 10.\n\nShe has worked for the past 20 years as a musculoskeletal physiotherapist and uses her rehab and strength and conditioning knowledge to build badminton-specific speed, strength and stability skills in young athletes.\n\nSarah is a Badminton England UKCC Level 2 Coach and has many years of badminton coaching experience from beginners through to county-level and junior international players.',
    achievements: ['Olympic Games Representative (Sydney 2000)', 'European Championship Medallist', 'World Top 10 Ranking', 'Badminton England UKCC Level 2 Coach', 'Musculoskeletal Physiotherapist'],
    philosophy: 'Using rehab and strength and conditioning knowledge to build badminton-specific speed, strength and stability skills in young athletes.'
  }];
  return <main className="bg-white pt-20" data-id="element-282">
      {/* 1. HERO SECTION */}
      <section className="relative overflow-hidden bg-brand-blue pt-28 pb-20 md:pt-36 md:pb-28 min-h-[320px] md:min-h-[400px]" data-id="element-283">
        <img src="https://cdn.magicpatterns.com/uploads/oReLAPLbn28EHKH4dsYqgd/Beijing-2008-Opening-Ceremony-DK-Photo-1-scaled.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" aria-hidden="true" data-id="element-284" />
        <div className="absolute inset-0 bg-brand-blue/80" data-id="element-285"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-286">
          <nav className="flex text-sm font-medium text-white/70 mb-8" data-id="element-287">
            <Link to="/" className="hover:text-white transition-colors" data-id="element-288">
              Home
            </Link>
            <span className="mx-2" data-id="element-289">/</span>
            <span className="text-white" data-id="element-290">About</span>
          </nav>

          <div className="max-w-3xl" data-id="element-291">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-6 leading-tight" data-id="element-292">
              Olympic-Level Coaching for{' '}
              <span className="text-brand-yellow" data-id="element-293">Lifelong Success</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed" data-id="element-294">
              Master FUNdamental motor skills in an inspiring, teamwork-driven
              environment, guided by our lead coaches Donna Kellogg MBE, Natalie
              Barton and Sarah Chapman, all Team GB Olympians.
            </p>
          </div>
        </div>
      </section>

      {/* 2. WHY BRIGHT STAR SPORTS SECTION */}
      <section className="py-24 bg-white" data-id="element-295">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-296">
          <div data-id="element-297">
            <SectionHeader eyebrow="Why Bright Star Sports?" title="The Gold Standard in Youth Coaching" align="left" data-id="element-298" />
            <ul className="space-y-4 text-navy-600 text-lg" data-id="element-299">
              {['Led by Team GB Olympians and world championship medallists', 'Structured programmes designed for ages 3 to 16', 'Focus on FUNdamental motor skills, confidence, and teamwork', 'Inclusive sessions welcoming all abilities and experience levels', 'Delivered in schools, sports centres, and community venues across the UK'].map((item, i) => <li key={i} className="flex items-start" data-id="element-300">
                  <CheckIcon className="w-6 h-6 text-brand-red mr-3 flex-shrink-0 mt-0.5" data-id="element-301" />
                  <span data-id="element-302">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden border border-navy-100" data-id="element-303">
            <img src="https://cdn.magicpatterns.com/uploads/oReLAPLbn28EHKH4dsYqgd/Beijing-2008-Opening-Ceremony-DK-Photo-1-scaled.jpg" alt="Team GB at the Beijing 2008 Olympic Opening Ceremony" className="w-full h-full object-cover" data-id="element-304" />
          </div>
        </div>
      </section>

      {/* 3. CORE VALUES SECTION */}
      <ValuesSection data-id="element-305" />

      {/* 4. TEAM SECTION */}
      <section className="py-24 bg-white" data-id="element-306">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-307">
          <SectionHeader eyebrow="Our Team" title="Meet the Team" description="Our lead coaches Donna Kellogg MBE, Natalie Barton and Sarah Chapman are all Team GB Olympians dedicated to inspiring the next generation through sport." data-id="element-308" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-309">
            {coaches.map((coach, index) => <CoachCard key={coach.id} coach={coach} index={index} onViewProfile={setSelectedCoach} data-id="element-310" />)}
          </div>
        </div>
      </section>

      {/* 5. DUAL CTA SECTION */}
      <section className="py-16 bg-navy-50" data-id="element-311">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-312">
          <div className="bg-brand-yellow rounded-2xl p-8 md:p-10 flex flex-col items-start" data-id="element-313">
            <h3 className="text-2xl md:text-3xl font-display font-bold text-navy-900 mb-4" data-id="element-314">
              Train Like Champions
            </h3>
            <p className="text-lg text-navy-800 mb-8 flex-1" data-id="element-315">
              Join our Olympian-led sessions and unlock your child's potential
              in a fun, supportive environment.
            </p>
            <Button href="/book" variant="primary" aria-label="Book a coaching session" data-id="element-316">
              Book a Session
            </Button>
          </div>

          <div className="bg-navy-900 rounded-2xl p-8 md:p-10 flex flex-col items-start" data-id="element-317">
            <h3 className="text-2xl md:text-3xl font-display font-bold text-white mb-4" data-id="element-318">
              Coach with Olympians
            </h3>
            <p className="text-lg text-navy-200 mb-8 flex-1" data-id="element-319">
              Join our team of passionate coaches and make a difference in the
              lives of young athletes.
            </p>
            <Button href="/become-a-coach" variant="secondary" className="border-white text-white hover:bg-white/20 focus:ring-white focus:ring-offset-navy-900 focus:ring-offset-2" aria-label="Learn more about coaching opportunities" data-id="element-320">
              Learn More
            </Button>
          </div>
        </div>
      </section>

      {/* Coach Modal */}
      <CoachModal coach={selectedCoach} isOpen={!!selectedCoach} onClose={() => setSelectedCoach(null)} data-id="element-321" />
    </main>;
}